import { Button, App, Modal } from 'antd';
import { logoutUser } from '@api';
import { PageEnum, ISLOGIN, ORGAN_TYPE } from '@/enums/pageEnum';
import { useNavigate } from 'react-router-dom';
import { setClearInfo } from '@/store/modules/app';
import { useAppDispatch } from '@/store';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const LoginButton = ({
  className,
  icon,
}: {
  className: string;
  icon?: React.ReactNode;
}) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { message } = App.useApp();
  return (
    <Button
      className={clsx('dark:text-[#ffffffD9] shadow-none', className)}
      onClick={() => {
        Modal.confirm({
          title: 'Log out',
          content: 'Are you sure you want to log out?',
          className: 'loginModalName',
          onOk: async () => {
            try {
              const res = await logoutUser();
              if (res.status === 200) {
                localStorage.removeItem(ISLOGIN);
                localStorage.removeItem(ORGAN_TYPE);
                dispatch(setClearInfo());
                message.success('Logout success.', 2);
                navigation(PageEnum.BASE_LOGIN, { replace: true });
              }
            } catch (error: any) {
              message.error(error?.detail || 'Logout failed.', 2);
            }
          },
        });
      }}
      icon={icon}
    >
      {t('logOut')}
    </Button>
  );
};

export default LoginButton;
